import React from 'react';
import { CheckIcon } from 'lucide-react';
import { solutionPoints } from '../data/content';
export function Solution() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-231" data-mp="1ek2p7swds9x4">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-232" data-mp="10tpi1srbcz8u">
        <h2 className="mx-auto max-w-narrow text-center font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-ink md:text-5xl" data-id="element-233" data-mp="10r385mgya7ng">
          El Atlas te da el sistema que te falta
        </h2>

        <ul className="mx-auto mt-12 grid max-w-3xl gap-4" data-id="element-234" data-mp="vu34tjbhjj01">
          {solutionPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-235" data-mp="hubm55a0xefp">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-500 text-white" data-id="element-236" data-mp="hw66ahdh12iq">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-237" data-mp="2c8ctyfnjxbrx" />
              </span>
              <span className="text-lg text-ink" data-id="element-238" data-mp="2c6i72vspz9l7">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}